export default class {
    onCreate() {
    }
    onInput(input) {
        return {
            tabsModule: input.tabsModule,
            searchModule: input.searchModule
        };
    }
    onMount() {
        this.handleStickyHeader();
    }
    handleStickyHeader() {
        this.rootEl = this.getEl('str-controlbar-wrap');
        document.addEventListener('sticky-headers-event', e => {
            const stickyClass = 'sticky';
            if (e.detail.isSticky) {
                this.rootEl.classList.add(stickyClass);
            } else {
                this.rootEl.classList.remove(stickyClass);
            }
        });
    }
}
